import React from "react";
import {
  Box,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Table,
} from '@material-ui/core';
import moment from 'moment';
import Paper from '@material-ui/core/Paper';

export default class ComponentToPrint extends React.Component {
  render() {
    const APRemovalDetailListData = this.props.APRemovalDetailListData;
    const selectedSearchValues = this.props.selectedSearchValues;

    const cellStyle = {
      fontSize: '9px',
      border: '1px solid #ccc'
    };

    return (
        <div>
          <h3><center><u>Advance Payments Removal Report</u></center></h3>
          <h4><center>Group: {selectedSearchValues.groupName} </center></h4>
          <h4><center>Factory: {selectedSearchValues.factoryName}</center></h4>
          <h5><center> {moment(selectedSearchValues.fromDate).format('YYYY/MM/DD')} -  {moment(selectedSearchValues.toDate).format('YYYY/MM/DD')}</center></h5>
          <div>&nbsp;</div>
          <div >
            <Box sx={{ minWidth: 1050 }}>
              <TableContainer>
                <Table aria-label="caption table" size="small">
                  <TableHead>
                    <TableRow style={{ border: '1px solid #ccc' }}>
                      <TableCell align={'center'} style={cellStyle}>Issuing Date</TableCell>
                      <TableCell align={'center'} style={cellStyle}>Removed Date</TableCell>
                      <TableCell align={'center'} style={cellStyle}>Route Name</TableCell>
                      <TableCell align={'center'} style={cellStyle}>Registration Number</TableCell>
                      <TableCell align={'center'} style={cellStyle}>Voucher Code</TableCell>
                      <TableCell align={'center'} style={cellStyle}>Source</TableCell>
                      <TableCell align={'center'} style={cellStyle}>Removed By</TableCell>
                      <TableCell align={'center'} style={cellStyle}>Amount</TableCell>

                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {APRemovalDetailListData.map((data, index) => (
                      <TableRow key={index} style={{ border: '1px solid #ccc' }}>
                        <TableCell align={'left'} component="th" scope="row" style={cellStyle}>
                          {data.issuingDate != null ? (moment(data.issuingDate).format('YYYY/MM/DD')) : null}
                        </TableCell>
                        <TableCell align={'left'} component="th" scope="row" style={cellStyle}>
                          {data.modifiedDate != null ? (moment(data.modifiedDate).format('YYYY/MM/DD')) : null}
                        </TableCell>
                        <TableCell align={'left'} component="th" scope="row" style={cellStyle}>
                          {data.routeName}
                        </TableCell>
                        <TableCell align={'left'} component="th" scope="row" style={cellStyle}>
                          {data.registrationNumber}
                        </TableCell>
                          <TableCell align={'left'} component="th" scope="row" style={cellStyle}>
                          {data.voucherCode}
                        </TableCell>
                         <TableCell align="left" component="th" scope="row" style={cellStyle}>
                          {data.advanceRequestType === 2
                            ? 'Over Advanced'
                            : data.advanceRequestType === 3
                              ? 'Direct Advanced'
                              : data.advanceRequestType}
                        </TableCell>
                        <TableCell align={'left'} component="th" scope="row" style={cellStyle}>
                          {data.userName}
                        </TableCell>
                        <TableCell align="right" component="th" scope="row" style={cellStyle}>
                          {data.approvedAmount ? data.approvedAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })  : '0.00'}
                        </TableCell>
                       
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </div>
          <div>&nbsp;</div>
          <h4><center>*******End of List*******</center></h4>
        </div>
    );
  }

}
